import React from 'react';
import { B } from '../constants';

export default function CreatorComingSoon() {
  return (
    <div style={{ marginTop: 16, padding: 18, borderRadius: 12, border: '1px dashed var(--reels-border, #e5e0d8)', background: 'var(--reels-card-bg, rgba(15,25,35,0.04))', textAlign: 'center', fontFamily: "'Montserrat',sans-serif" }}>
      <span style={{ background: B.amber, color: B.night, padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}>Coming soon</span>
      <p style={{ marginTop: 10, fontSize: 15, fontWeight: 800, color: 'var(--reels-fg, #0f1923)' }}>🌟 Creator program</p>
      <p style={{ marginTop: 4, fontSize: 13, color: 'var(--reels-muted, #5b6470)' }}>Promoted creator features are on their way.</p>
    </div>
  );
}
